import { useState, useEffect, useMemo } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import http from 'http'
import { withProfile } from 'context/Profile'
import PathDetail from 'components/PathDetail'

import {
  FiMap,
  FiArrowLeft,
  FiSearch,
  FiChevronsLeft,
  FiChevronLeft,
  FiChevronsRight,
  FiChevronRight,
  FiFilter,
} from 'react-icons/fi'

const Paths = ( {
  withProfile: { user }
} ) => {
  const navigate = useNavigate()
  const [ searchParams, setSeachParams ] = useSearchParams()
  const [ routeList, setRouteList ] = useState()
  const [ total, setTotal ] = useState()
  const [ selectedRoute, setSelectedRoute ] = useState()

  const [ options, setOptions ] = useState( {
    __as: 'page',
    __match: { by: user.id },
    __sort: { at: -1 },
    __limit: 10,
    __offset: 0
  } )

  useMemo( () => {
    let no = {}

    for ( let entry of searchParams.entries() ) {
      const [ key, value ] = entry

      no[ key ] = value
    }

    setOptions( ( options ) => {
      return { ...options, ...no }
    } )
  }, [ searchParams ] )

  useEffect( () => {
    http( {
      method: 'POST',
      url: '/mongo/findMany',
      data: {
        __model: 'Route',
        __select: {
          name: 1
        },
        ...options
      }
    } )
      .then( ( { data } ) => {
        setRouteList( list => data.page )
        setTotal( total => data.total )
      } )

  }, [ options ] )

  const back = () => {
    navigate( '/main' )
  }

  const search = () => {
    console.log( 'search' )
  }

  const next = () => {
    const offset = parseInt( options.__offset ) + parseInt( options.__limit )

    if ( offset < total ) {
      setSeachParams( ( searchParams ) => {
        searchParams.set( '__offset', offset )
        return searchParams
      } )
    }
  }

  const prev = () => {
    const offset = parseInt( options.__offset ) - parseInt( options.__limit )

    if ( offset >= 0 ) {
      setSeachParams( ( searchParams ) => {
        searchParams.set( '__offset', offset )
        return searchParams
      } )
    }
  }

  const first = () => {
    if ( parseInt( options.__offset ) === 0 )
      return

    setSeachParams( ( searchParams ) => {
      searchParams.set( '__offset', 0 )
      return searchParams
    } )
  }

  const last = () => {
    const rest = total % parseInt( options.__limit )
    let offset = 0

    if ( rest > 0 )
      offset = total - rest
    else
      offset = total - options.__limit

    if ( offset === parseInt( options.__offset ) )
      return

    setSeachParams( ( searchParams ) => {
      searchParams.set( '__offset', offset )
      return searchParams
    } )
  }

  const openRoute = ( route ) => {
    // const to = `/routes/${ route._id }`

    // navigate( to )
    setSelectedRoute( () => route )
  }
 
  if ( ! routeList )
    return null

  return <section className="one hs air-2x gap-2x">

    <div className="bar">
      <button
        onClick={ back }
      >
        <FiArrowLeft />
      </button>

      <input
        size={ 1 }
        placeholder="routes"
      />

      <button
        onClick={ search }
      >
        <FiSearch />
      </button>

      <button
        onClick={ search }
      >
        <FiFilter />
      </button>
    </div>

    <ul className="list-menu">
      { routeList.map( ( route, ix ) => <li
        key={ ix }
        className="list-item"
        onClick={ () => openRoute( route ) }
      >
        <span className="icon">
          <FiMap />
        </span>

        <span className="one text">
          { route.name }
        </span>
      </li> ) }

    </ul>

    <div className="bar">
      <button
        onClick={ first }
      >
        <FiChevronsLeft />
      </button>

      <button
        onClick={ prev }
      >
        <FiChevronLeft />
      </button>

      <h1 className="ta-center">
        { parseInt( options.__offset ) + 1 }
        &nbsp;
        -
        &nbsp;
        { ( parseInt( options.__offset ) + parseInt( options.__limit ) ) < total ? parseInt( options.__offset ) + parseInt( options.__limit ) : total }
        &nbsp;
        /
        &nbsp;
        { total }
      </h1>

      <button
        onClick={ next }
      >
        <FiChevronRight />
      </button>

      <button
        onClick={ last }
      >
        <FiChevronsRight />
      </button>
    </div>

    { selectedRoute ? <PathDetail
      { ...selectedRoute }
      close={ () => setSelectedRoute( () => null ) }
    /> : null }
  </section>
}

export default withProfile( Paths )
